import * as React from 'react';
import { observer } from "mobx-react-lite";
import { Button } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeftIcon } from '@heroicons/react/20/solid';

import { orderController } from "../Controllers/OrderController";
import { StripeCardForm } from "../Components/StripeCardForm";

export const PaymentSubpage = observer(() => {
  const PREV_STEP = 1
  const CURRENT_STEP = 2;

  orderController.activeStep = CURRENT_STEP;

  const navigate = useNavigate();

  const navigateToDeliveryDetails = () => {
    orderController.activeStep = PREV_STEP;
    navigate("/checkout/step-2")
  }

    useEffect(() => {
      if (!orderController.isPaymentPossible()){
        navigateToDeliveryDetails();
      }
    }, []);

  useEffect(() => {
    const handleResize = () => {
      orderController.activeStep = PREV_STEP;
      orderController.activeStep = CURRENT_STEP;
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="flex flex-col justify-center h-full">
      <div className="flex flex-col gap-4 flex-auto h-0 mt-4 items-center overflow-y-auto">
        <StripeCardForm />
        <p className="text-gray-400 justify-center">Should you wish to pay via Bank Transfer - Please email us at <a className="underline" href="mailto:stockists@newsstand.co.uk">stockists@newsstand.co.uk</a></p>
      </div>
      <div className="flex flex-none md:p-2 justify-start overflow-hidden border-t-2 border-white">
        <Button
          size={"md"}
          className={"rounded-none h-auto w-full md:w-auto"}
          color={"white"}
          onClick={navigateToDeliveryDetails}
        >
          <div className="flex justify-center items-center"><ArrowLeftIcon color={"black"} className={"d-inline h-4 w-4"} /><span className="ml-2 text-xl">Delivery Details</span></div>
        </Button>
      </div>
    </div>
  )
})
